import React from 'react';
import './ParentPeopleLevels.scss';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import ParentPeopleLevelPointer from './ParentPeopleLevelPointer';
import emptyIcon from '../../../../../../assets/reports/parent/person-gray.png';
import atAboveIcon from '../../../../../../assets/reports/parent/person-blue.png';
import onTrackIcon from '../../../../../../assets/reports/parent/person-green.png';
import developingIcon from '../../../../../../assets/reports/parent/person-yellow.png';
import behindIcon from '../../../../../../assets/reports/parent/person-red.png';
import { hexCodes } from '../../../util/cutscores';

const ParentPeopleLevels = ({ pacing, percentage, i18n, percentileInfo }) => {

  const {t} = useTranslation(['teacher_parent_report'], {i18n})

  const totalIcons = 5;

  return (
    <div className="rating-icons-container">
      <div className='rating-icons'>
      {[...Array(totalIcons)].map((_, index) => {

        const iconClass = cx({
          'rating-icon': true,
        });

        return <div className={iconClass} key={index}>
          <img src={getIcon(pacing, percentage, totalIcons, index, percentileInfo)} alt="" role="none" className='_icon' />
        </div>
      })}
        <ParentPeopleLevelPointer positionPercent={percentage} />
      </div>
      <span className="rating-text">{t(`Scored better than {{percentage}}% of students`, {percentage})}</span>
    </div>
  );
};

export default ParentPeopleLevels;

function getIcon(pacing, percentage, totalIcons, index, percentileInfo) {
  
  const activeIcons = Math.ceil((percentage / 100) * totalIcons);
  
  if (index >= activeIcons) {
    return emptyIcon;
  }

  if (percentileInfo) {
    switch (percentileInfo.color) {
      case hexCodes.BLUE:
        return atAboveIcon;
      case hexCodes.GREEN:
        return onTrackIcon;
      case hexCodes.YELLOW:
        return developingIcon;
      case hexCodes.RED:
        return behindIcon;
      default:
        return emptyIcon;
    }
  }

  if (pacing === 'BELOW_GRADE_LEVEL') {
    return behindIcon;
  } else if (pacing === 'AT_GRADE_LEVEL') {
    return developingIcon;
  } else if (pacing === 'AHEAD_OF_GRADE_LEVEL') {
    return onTrackIcon;
  } else {
    return emptyIcon;
  }
}